import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../_services/auth.service';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { ALinkDirective } from './_directive/a-link.directive';






@NgModule({
  imports: [
    CommonModule
  ],
  providers: [AuthService],
  declarations: [

  

  
  ]
})
export class CoreModule { }
